var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app-bar",
    {
      staticClass: "pt-4 mx-2 pl-4 pr-6 grey-background",
      staticStyle: {
        top: "56px",
        "z-index": "5",
        transition: "none !important",
      },
      style: `${
        _vm.scroll > 80
          ? "box-shadow: 2px 4px 6px -6px rgba(69, 90, 100, 0.15) !important;"
          : ""
      };`,
      attrs: { flat: "", height: _vm.dense ? "11" : "35", app: "", fixed: "" },
      scopedSlots: _vm._u(
        [
          {
            key: "extension",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 pa-0 mt-n3 mx-6 d-flex justify-end none",
                  },
                  [
                    _vm._t("custom-tab"),
                    !_vm.hiddenTab
                      ? [
                          _c(
                            "v-tabs",
                            {
                              staticClass:
                                "mt-n3 pt-8 pl-4 pr-5 grey-background",
                              staticStyle: {
                                position: "absolute",
                                "z-index": "0 !important",
                              },
                              attrs: { height: 35 },
                              model: {
                                value: _vm.current,
                                callback: function ($$v) {
                                  _vm.current = $$v
                                },
                                expression: "current",
                              },
                            },
                            [
                              _c(
                                "v-tab",
                                { attrs: { ripple: false } },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", size: "18" } },
                                    [_vm._v(_vm._s(_vm.iconAllTab))]
                                  ),
                                  _vm._v("Todos "),
                                ],
                                1
                              ),
                              _vm._l(_vm.list, function ({ key }, index) {
                                return _c(
                                  "v-tab",
                                  { key: index, attrs: { ripple: false } },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { left: "", size: "18" } },
                                      [_vm._v(_vm._s(_vm.status[index]?.icon))]
                                    ),
                                    _vm._v(_vm._s(key) + " "),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "d-flex mt-1 pr-5",
                              staticStyle: { position: "absolute" },
                            },
                            [_vm._t("grey-700")],
                            2
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _c("v-toolbar-title", { staticClass: "grey-700--text" }, [
        _c(
          "span",
          {
            staticClass: "d-block subtitle-1 font-weight-semibold",
            class: _vm.dense ? "pt-7" : "pt-1",
          },
          [
            _vm._v(" " + _vm._s(_vm.breadcrumbs.main) + " "),
            ((_vm.breadcrumbs || {}).children || []).length
              ? _c(
                  "v-icon",
                  {
                    staticClass: "mx-1",
                    attrs: { color: "grey-700", size: "20" },
                  },
                  [_vm._v("mdi-chevron-right")]
                )
              : _vm._e(),
            _vm._l(_vm.breadcrumbs.children, function (b, i) {
              return _c(
                "span",
                { key: i },
                [
                  b.route
                    ? _c(
                        "router-link",
                        {
                          staticClass: "text-decoration-none grey-700--text",
                          attrs: {
                            to:
                              typeof b.route === "string"
                                ? {
                                    name: b.route,
                                    query: _vm.query,
                                    params: _vm.currentParams,
                                  }
                                : b.route,
                          },
                        },
                        [_vm._v(_vm._s(b.text))]
                      )
                    : [
                        _vm._v(
                          _vm._s(
                            b.text === "SII" ? _vm.$t("generals.SII") : b.text
                          )
                        ),
                      ],
                  b.text1
                    ? [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mx-1",
                            attrs: { color: "grey-700", size: "20" },
                          },
                          [_vm._v("mdi-chevron-right")]
                        ),
                        b.route1
                          ? _c(
                              "v-btn",
                              {
                                staticStyle: {
                                  "justify-content": "start",
                                  padding: "0 !important",
                                },
                                attrs: {
                                  to:
                                    b.route1 === "string"
                                      ? {
                                          name: b.route1,
                                          query: _vm.query,
                                          params: {
                                            ...(_vm.query.ref
                                              ? { id: _vm.query.ref }
                                              : {}),
                                          },
                                        }
                                      : b.route1,
                                  text: "",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "subtitle-1 grey-700--text font-weight-semibold",
                                    staticStyle: {
                                      "max-width": "290px",
                                      display: "inline-block",
                                      overflow: "hidden",
                                      "text-overflow": "ellipsis",
                                      "white-space": "nowrap",
                                      position: "relative",
                                      top: "-2px",
                                    },
                                  },
                                  [_vm._v(_vm._s(b.text1))]
                                ),
                              ]
                            )
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "subtitle-1 grey-700--text font-weight-semibold",
                                staticStyle: {
                                  "max-width": "350px",
                                  position: "relative",
                                  top: "8px",
                                  display: "inline-block",
                                  overflow: "hidden",
                                  "text-overflow": "ellipsis",
                                  "white-space": "nowrap",
                                },
                              },
                              [_vm._v(_vm._s(b.text1))]
                            ),
                      ]
                    : _vm._e(),
                  b.text2
                    ? [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mx-1",
                            attrs: { color: "grey-700", size: "20" },
                          },
                          [_vm._v("mdi-chevron-right")]
                        ),
                        b.route2
                          ? _c(
                              "v-btn",
                              {
                                staticStyle: {
                                  "justify-content": "start",
                                  padding: "0 !important",
                                },
                                attrs: { to: b.route2, text: "" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "d-inline-block text-truncate subtitle-1 grey-700--text font-weight-semibold",
                                    staticStyle: { "max-width": "200px" },
                                  },
                                  [_vm._v(_vm._s(b.text2))]
                                ),
                              ]
                            )
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "subtitle-1 grey-700--text font-weight-semibold",
                                staticStyle: {
                                  "max-width": "350px",
                                  position: "relative",
                                  top: "8px",
                                  display: "inline-block",
                                  overflow: "hidden",
                                  "text-overflow": "ellipsis",
                                  "white-space": "nowrap",
                                },
                              },
                              [_vm._v(_vm._s(b.text2))]
                            ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            }),
            Object.keys(_vm.breadcrumbsItemDinamic).length
              ? _c(
                  "v-icon",
                  {
                    staticClass: "mx-1",
                    attrs: { color: "grey-700", size: "22" },
                  },
                  [_vm._v("mdi-chevron-right")]
                )
              : _vm._e(),
            _vm.breadcrumbsItemDinamic.loading
              ? _c("v-avatar", {
                  staticClass: "grey-50 rounded-pill",
                  attrs: { tile: "", height: "15", width: "200" },
                })
              : [_vm._v(_vm._s(_vm.breadcrumbsItemDinamic.text))],
            _vm.tooltip.length
              ? _c(
                  "v-tooltip",
                  {
                    attrs: {
                      color: "white-0",
                      right: "",
                      "max-width": "250px",
                      transition: "scale-transition",
                      "z-index": "1000",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "span",
                                _vm._g(
                                  { staticClass: "grey-700--text body-1" },
                                  on
                                ),
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "ml-2",
                                      attrs: { small: "", color: "grey-700" },
                                    },
                                    [_vm._v("mdi-information")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3813560050
                    ),
                  },
                  [
                    _c("span", { staticClass: "d-block px-3 py-2" }, [
                      _vm._v(_vm._s(_vm.tooltip)),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
          2
        ),
        _vm.inf
          ? _c("span", { staticClass: "d-block subtitle-2 mt-3" }, [
              _vm._v(_vm._s(_vm.inf)),
            ])
          : _vm._e(),
      ]),
      _c("v-spacer"),
      _c(
        "v-toolbar-items",
        { staticClass: "pr-0 mr-n2 pb-0" },
        [
          _c(
            "v-row",
            { attrs: { align: "center", justify: "end", "no-gutters": "" } },
            [_vm._t("main")],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }